import { useState, useEffect } from "react";
import { client } from "../sanity/client";

function Skills() {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    client.fetch('*[_type == "skills"][0]').then((data) => {
      console.log(data);
      setSkills(data?.items || []);
    });
  }, []);
  return (
    <>
      <p>
        <span className="prompt">ziad@portfolio:</span>
        <span className="path">~</span>
        <span className="command">$ cd skills</span>
      </p>

      <div className="section">
        <div className="grid">
          {skills.map((skill, index) => (
            <span key={index}>▸ {skill}</span>
          ))}
        </div>
      </div>
    </>
  );
}
export default Skills;
